import React from 'react';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const formatCurrency = (v) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(v || 0);

export default function FaturamentoMensalChart({ dados, loading }) {
  if (loading) {
    return (
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid rgba(25,118,210,0.2)', minHeight: 320, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={32} />
      </Paper>
    );
  }

  const meses = dados?.meses || [];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        height: '100%',
        border: '1px solid rgba(25,118,210,0.2)',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(227,242,253,0.4) 100%)',
        boxShadow: '0 4px 24px rgba(25,118,210,0.08)'
      }}
    >
      <Typography variant="h6" fontWeight={700} color="primary">
        Faturamento Mensal (Notas Fiscais)
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Evolução do valor líquido lançado por competência — {dados?.ano || new Date().getFullYear()}.
      </Typography>
      {meses.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 6 }}>
          Nenhum lançamento de NF encontrado para o filtro aplicado.
        </Typography>
      ) : (
        <Box sx={{ width: '100%', height: 280 }}>
          <ResponsiveContainer>
            <LineChart data={meses} margin={{ top: 8, right: 16, left: 8, bottom: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
              <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#546e7a' }} interval={0} />
              <YAxis tickFormatter={(v) => formatCurrency(v)} tick={{ fontSize: 11, fill: '#546e7a' }} width={88} />
              <Tooltip formatter={(value) => [formatCurrency(value), 'Valor líquido']} labelFormatter={(l) => `Competência: ${l}`} />
              <Line type="monotone" dataKey="valorLiquido" stroke="#1976d2" strokeWidth={2.5} dot={{ r: 4 }} activeDot={{ r: 6 }} />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      )}
    </Paper>
  );
}
